module.exports = __webpack_public_path__ + "media/images/UCI-logo-1f385dd713b04944b0131e438b05064f.jpg";